import { render, staticRenderFns } from "./tasksecondaryTable.vue?vue&type=template&id=26fbc045&scoped=true"
import script from "./tasksecondaryTable.vue?vue&type=script&lang=js"
export * from "./tasksecondaryTable.vue?vue&type=script&lang=js"
import style0 from "./tasksecondaryTable.vue?vue&type=style&index=0&id=26fbc045&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26fbc045",
  null
  
)

export default component.exports